import React from 'react'

export default function DotsMenuIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none">
            <path d="M12 6C13.65 6 15 4.65 15 3C15 1.35 13.65 0 12 0C10.35 0 9 1.35 9 3C9 4.65 10.35 6 12 6ZM12 9C10.35 9 9 10.35 9 12C9 13.65 10.35 15 12 15C13.65 15 15 13.65 15 12C15 10.35 13.65 9 12 9ZM12 18C10.35 18 9 19.35 9 21C9 22.65 10.35 24 12 24C13.65 24 15 22.65 15 21C15 19.35 13.65 18 12 18Z" fill="currentcolor" />
        </svg>
    )
}